import { formatDateWithTimeAMPM } from "@/shared";
import CustomCantidadInput from "@/shared/components/ui/CustomCantidadInput";
import { IProductoTomaFisica, ITomaFisica } from "@/shared/interfaces/erp/contabilidad/toma_fisica.interface";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

interface IFormTomaFisica {
  numero_referencia: string;
  codigo: string;
  fecha_toma_fisica: string;
  ubicacion: string;
  centro_costo: string;
  estado: boolean;
  producto: string | null;
  bodega: string | null;
}


export default function useFormTomaFisica({
  dataTomaFisica
}: {
  dataTomaFisica?: ITomaFisica | null
}) {


  const [cantidadMap, setCantidadMap] = useState<{ [key: string]: IProductoTomaFisica }>({});


  const columnsTomaFisica = useMemo<MRT_ColumnDef<IProductoTomaFisica>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'codigo',
      Cell: ({ row }) => row.original.producto_data?.codigo
    },
    {
      accessorKey: 'descripcion',
      header: 'descripcion',
      Cell: ({ row }) => row.original.producto_data?.descripcion
    },
    {
      accessorKey: 'stock',
      header: 'stock sistema',
      Cell: ({ row }) => row.original?.stock
    },
    {
      accessorKey: "cantidad_ingresada",
      header: "Cantidad a ingresar",
      size: 125,
      Cell: ({ row }) => (
        <CustomCantidadInput<IProductoTomaFisica>
          value={cantidadMap[row.original.id_ubicacion_producto!]?.cantidad || "0"}
          handleValue={(value) => {

            handleCantidadChange({
              codigo: row.original.codigo,
              id_ubicacion_producto: row.original.id_ubicacion_producto!,
              stock: row.original.stock.toString(),
              series: [],
              /* unidad_medida: row.original.producto_data?.unidad_medida,
              costo_promedio: row.original.producto_data?.costo_promedio,
              bodega: row.original?.bodega,
              bodega: row.original.ubicacion */
            }, value)

          }
          }
          row={row}
        />
      ),
    },

    {
      accessorKey: 'unidad',
      header: 'unidad',
      Cell: ({ row }) => row.original.producto_data?.unidad_medida ?? 'N/A'

    },
    {
      accessorKey: 'costo',
      header: 'costo',
      Cell: ({ row }) => row.original.producto_data?.costo_promedio
    },
    {
      accessorKey: 'total',
      header: 'total',
      Cell: ({ row }) => +row.original.stock * row.original.producto_data?.costo_promedio!

    },
    {
      accessorKey: 'bodega',
      header: 'bodega',
      Cell: ({ row }) => row.original.bodega_data?.nombre
    },
    {
      accessorKey: 'ubicacion',
      header: 'ubicacion',
      Cell: ({ row }) => row.original.ubicacion_data?.nombre
    },
    {
      accessorKey: 'centro_costo',
      header: 'centro costo',
      Cell: () => 'PENDIENTE'
    },

  ], [cantidadMap])


  ///* form
  const form = useForm<IFormTomaFisica>({
    defaultValues: {
      fecha_toma_fisica: formatDateWithTimeAMPM(new Date),
      estado: true
    }
  })

  const {
    reset,
  } = form


  ///* react query

  ///* handle
  const handleCantidadChange = (row: IProductoTomaFisica, value: string) => {

    setCantidadMap((prev) => ({
      ...prev,
      [row.id_ubicacion_producto!]: { ...row!, cantidad: value },
    }));
  };


  const mapping = useMemo(() => {
    if (!dataTomaFisica) return {};
    const dataProductos = dataTomaFisica.productos;
    const result: { [key: string]: IProductoTomaFisica } = {};
    for (let i = 0; i < dataProductos.length; i++) {
      const item = dataProductos[i];
      result[item.id_ubicacion_producto] = item;
    }
    return result;
  }, [dataTomaFisica]);

  useEffect(() => {


    if (!dataTomaFisica) return;
    setCantidadMap(mapping);
    reset({ ...dataTomaFisica });

    return () => {
      reset({})
    }

  }, [dataTomaFisica, mapping])



  return {
    form,
    cantidadMap,
    setCantidadMap,
    columnsTomaFisica
  }

}